import { PaginationProps } from 'antd'

export const paginationConfig: PaginationProps = {
  hideOnSinglePage: false,
  showQuickJumper: true,
  showSizeChanger: true,
  showTitle: true,
  showTotal: (all, range) => `第 ${range[0]}-${range[1]} 条/总共 ${all} 条`
}
